<template>
  <div
    class="betslip"
    v-if="betslipConfig"
    :class="[activeTab.name]"
    v-max-height="{ offset: 2 }">
    <div
      v-if="workingTimeBlocker"
      class="working-time-blocker">
      <i class="icon n-i-lock" />
      {{ workingTimeBlocker }}
    </div>
    <modal
      @modalclosed="showSystemModal = false"
      :show="showSystemModal">
      <div slot="header">
        {{ getTranslation('select.system') }}
      </div>
      <div slot="body">
        <div class="systems-wrapper">
          <div
            class="system-item-wrapper"
            v-for="system in systems"
            :key="system.id">
            <system
              :system="system"
              :bankers="bankers"/>
          </div>
        </div>
      </div>
      <div slot="footer">
        <div class="footer-buttons">
          <div class="numbers-wrapper">
            <div class="number-wrapper button-ok button-half button-right">
              <div class="number">OK</div>
            </div>
          </div>
        </div>
      </div>
    </modal>

    <modal
      :show="showStakeModal"
      position="betslip-stake"
      @modalclosed="showStakeModal = false">
      <div slot="header">Insert number</div>
      <div slot="body">
        <div class="modal-stake-wrapper">
          <input
            type="text"
            :value="currentStakeModalValue || stake">
        </div>
        <div class="numbers-wrapper">
          <div
            class="number-wrapper"
            v-for="(val, index) in [1, 2, 3, 4, 5, 6, 7, 8, 9, '.', 0, 'C']"
            :key="index"
            @click.stop="enterKey(val);">
            <div class="number">{{ val }}</div>
          </div>
        </div>
      </div>
      <div slot="footer">
        <div class="numbers-wrapper">
          <div class="number-wrapper">
            <div
              class="number button"
              @click.stop="enterKey('DEL')">DEL</div>
          </div>
          <div class="number-wrapper button-ok">
            <div
              class="number"
              @click="enterKey('OK')">OK</div>
          </div>
        </div>
      </div>
    </modal>
    <div :class="['tabs', `tabs-${tabs.length}`]">
      <div
        class="tab"
        :class="{ active: tab.id == activeTab.id }"
        v-for="tab in tabs"
        @click.stop="changeType(tab)"
        :key="tab.id"
      >{{ getTypeName(tab.name) }}</div>
    </div>
    <div v-if="items && items.length">
      <scroller :hide-to-top="true">
        <div
          v-max-height="{ el: ['.tabs', '.betslip-footer'], offset: 50 }"
          class="items-container"
        >
          <div
            v-for="item in items"
            :key="item.key"
            class="item"
            @click="goToEventView(item)"
          >
            <div
              class="system-wrapper"
              @click.stop="toggleBanker(item.key)"
              v-if="activeTab.id === '2'">
              <i :class="{ 'n-i': true, 'n-i-circle': !item.banker, 'n-i-check-a': item.banker }"/>
            </div>
            <div class="item-wrapper">
              <div class="title">{{ item.title }}</div>
              <div class="subtitle">{{ item.subtitle }}</div>
              <div
                class="pick"
                :class="{
                  'change-up': item.change === 'UP',
                  'change-down': item.change === 'DOWN',
                }"
              >
                <div class="outcome-name">
                  {{ item.outcome }}
                </div>
                <div class="outcome-value">{{ item.oddDisplay[oddType] }}</div>
              </div>
              <div
                v-if="activeTab.id === '3'"
                class="pick stake">
                <div class="outcome-name"> {{ getTranslation('main.stake') }} </div>
                <div class="outcome-value">{{ singleStake }}</div>
              </div>
            </div>
            <div
              class="remove-button"
              @click.stop="removeBet(item)">
              <div class="icon-wrapper">
                <i class="n-i n-i-plus"/>
              </div>
            </div>
            <div
              :class="item.oddChange ? item.oddChange.toLowerCase() : ''"
              class="outcome-value">
              <span
                class="old-outcome-value"
                v-if="item.oldOddDisplay && item.oddValue !== item.oldOddValue">
                {{ item.oldOddDisplay[oddType] }}
              </span>
              <span
                class="odd-change-wrapper"
                v-if="item.oddChange">
                <i
                  class="n-i"
                  :class="['n-i-arrow-' + item.oddChange.toLowerCase()]"/>
              </span>
            </div>
          </div>
        </div>
      </scroller>
    </div>
    <div
      v-else
      v-max-height="{ el: ['.tabs', '.betslip-footer'], offset: -10 }"
      class="items-container no-items">
      <div class="empty-text">
        <span>{{ getTranslation('betslip.pick_outcome_message_first_line') }} </span>
        <span class="alt-no-items">{{ getTranslation('betslip.start_betting_message') }}</span>
        <div class="icon-wrapper">
          <i class="n-i n-i-arrow-left-a"/>
        </div>
      </div>
    </div>

    <div class="betslip-footer">
      <div
        class="systems"
        @click.stop="showSystemModal = true"
        v-if="activeTab.id === '2' && systems.length">
        <span v-if="selectedSystems.length == 0">{{ getTranslation('select.system') }} </span>
        <i class="n-i n-i-arrows"/>  {{ numOfBankers? `${numOfBankers}B +`: '' }}
        <span v-if="selectedSystems.length > 0">
          <span
            v-for="(selSystem, index) in selectedSystems"
            :key="selSystem.id">{{ selSystem.id }}
            <span
              v-if="systems.filter(item => item.active).length > 1
              && index < systems.filter(item => item.active).length - 1">, </span>
            <span
              v-if="index === systems.filter(item => item.active).length - 1">
              / {{ systems.length }}
            </span>
          </span>
        </span>
      </div>
      <div class="stake-buttons">
        <div
          class="button-wrapper"
          v-for="(buttonStake, index) in moneyDenominations"
          :key="index"
          @click.stop="changeStake(buttonStake)">
          <div class="button">
            {{ buttonStake }}
          </div>
        </div>
      </div>

      <div class="payment">
        <div
          class="max-payin"
          @click="changeStake(maxStake)">
          <div class="button">Max</div>
        </div>
        <div
          class="stake-wrapper"
          @click.stop="showStakeModal = true">
          <div class="stake-control">
            <div class="stake-label">{{ getTranslation('main.payin') }}</div>
            <input
              class="stake"
              type="text"
              :value="stake"
              readonly>
          </div>
        </div>
      </div>

      <div
        class="footer-row"
        v-if="activeTab.id === '1'">
        <div class="label">{{ getTranslation('betslip.total_odds') }}</div>
        <div class="value">{{ totalOdds }}</div>
      </div>
      <div
        class="footer-row"
        v-if="bonusConfig && bonusConfig.type && winnings.bonusPercent">
        <div class="label">{{ getTranslation('main.bonus') }} ({{ winnings.bonusPercent }}%)</div>
        <div class="value">{{ winnings.bonus.toFixed(2) }}</div>
      </div>
      <div class="footer-row alt">
        <div class="label">{{ getTranslation('betslip.possible_winning') }}</div>
        <div class="value">{{ parseFloat(winnings.max).toFixed(2) }}</div>
      </div>
      <div class="footer-row">
        <div class="label">{{ getTranslation('main.payin_tax') }}</div>
        <div class="value">{{ payinTax }}</div>
      </div>

      <div class="footer-buttons">
        <div
          class="remove-wrapper"
          @click="clearBetslip()">
          <div class="remove-button">
            <i class="n-i n-i-trash"/>
          </div>
        </div>
        <div
          class="payin-wrapper"
          @click="payin">
          <button
            class="payin-button"
            :disabled="payinDisabled">
            <i class="n-i n-i-betslip-options"/>
            {{ getTranslation('betslip.pay_in') }}
          </button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Moment from 'moment';
import gravityTax from '@nsftx/seven-gravity-tax-service';
import GravityGateway from '../../../services/gravityGateway';
import { calculateWinnings } from '../../../services/betslip';
import Modal from '../modal/Modal.vue';
import System from './System.vue';

export default {
  components: {
    Modal,
    System,
  },
  mounted() {
    this.$store.dispatch('setDefaultStake');
  },
  data() {
    return {
      showSystemModal: false,
      showStakeModal: false,
      currentStakeModalValue: '',
      defaultType: '',
    };
  },
  computed: {
    payinDisabled() {
      return this.items.length === 0;
    },
    defaultTicketType() {
      return this.$store.getters.getCompanyConfig.ticket.activeType;
    },
    oddType() {
      return this.$store.getters.getActiveOddType;
    },
    moneyDenominations() {
      return this.$store.getters.getMoneyDenominations;
    },
    maxStake() {
      return this.$store.getters.getMoneyBalance;
    },
    totalOdds() {
      return this.$store.getters.getTotalOdds.toFixed(2);
    },
    betslipConfig() {
      return this.$store.getters.getBetslipConfig;
    },
    tabs() {
      return this.$store.getters.getBetslipTabs;
    },
    activeTab() {
      return this.$store.getters.getBetslipActiveTab;
    },
    items() {
      return this.$store.getters.getBetslipBets;
    },
    bankers() {
      return this.$store.getters.getBankerBets.length;
    },
    rules() {
      return this.$store.getters.getBetslipRules;
    },
    stake() {
      const { stake } = this.$store.state.betslip;
      return stake.toFixed(2);
    },
    payinTax() {
      return gravityTax.calculateTax(
        this.betslipConfig.taxes.payin.policy,
        this.stake,
      ).taxAmountRounded.toFixed(2);
    },
    singleStake() {
      return this.$store.getters.getSingleStake;
    },
    numOfBankers() {
      return (_.filter(this.items, { banker: true })).length;
    },
    selectedSystems() {
      return _.filter(this.systems, { active: true });
    },
    systems() {
      return this.$store.getters.getBetslipSystems;
    },
    bonusConfig() {
      return this.$store.getters.getBonusConfig;
    },
    winnings() {
      let bonusConfig;
      if (this.bonusConfig && this.bonusConfig.type && this.bonusConfig.type.toUpperCase() === 'ODD_PERCENTAGE_BONUS') {
        bonusConfig = this.bonusConfig.oddCountRules;
      }

      return calculateWinnings({
        bets: this.items,
        stake: this.stake,
        betslipConfig: this.betslipConfig,
        ticketType: parseInt(this.activeTab.id, 10),
        systems: this.systems,
        bonusConfig,
      });
    },
    workingTimeBlocker() {
      return this.$store.getters.workingTimeBlocker;
    },
  },
  methods: {
    removeBet(bet) {
      this.$store.dispatch('removeBet', bet);
    },
    payin() {
      const company = this.$store.getters.getCompany;
      const stake = parseFloat(this.stake, 10);
      const ticketType = parseInt(this.activeTab.id, 10);
      const ticket = {
        bets: [],
        action: 'Add',
        payin: stake,
        stake,
        product: 'PreMatchBetting',
        translation: this.$store.getters.getTranslation('games.prematchbetting'),
        ticketType,
        ticketComment: `${company.name}-v2`,
        ticketCombinationGroups: [],
        ticketFormatted: false,
        id: this.activeTab.name,
        getStake: stake,
        config: {
          id: this.activeTab.name,
          ticketType: this.activeTab,
          setFormatPayin: false,
          group: {
            id: 'PreMatchBetting',
            taxesConfig: {
              payin: this.betslipConfig.taxes.payin,
              payout: this.betslipConfig.taxes.payout,
            },
          },
        },
      };


      // Single tickets
      if (ticketType === 3) {
        ticket.ticketCombinationGroups = [
          {
            events: this.items.length,
            parlays: 1,
          },
        ];
      }

      // System tickets
      if (ticketType === 2) {
        ticket.ticketCombinationGroups = [];

        this.selectedSystems.forEach((system) => {
          ticket.ticketCombinationGroups.push({
            events: system.of,
            parlays: system.id,
          });
        });
      }

      let cantBePlayed = 0;

      this.items.forEach((item) => {
        const now = new Moment();
        const nowUTC = parseInt(Moment.utc(now).format('x'), 10);

        const bet = {
          idMatchBetOutcome: item.key,
          mboOddValue: parseFloat(item.oddValue),
          outcomeOdd: parseFloat(item.oddValue),
          ticketBetBank: ticketType === 1 ? 1 : 0, // Combo ticket
          ticketBetWay: 0,
          matchName: item.title,
          matchDisplayId: item.matchDisplayId,
          matchDateTimeUTC: item.matchDateTimeUTC,
          betName: item.subtitle,
          betOutcomeName: item.outcome,
        };

        if (nowUTC - bet.matchDateTimeUTC > 0) {
          this.$store.dispatch('addNotification', {
            type: 'WARNING',
            message: this.getTranslation('betslip.match_started').replace('{{matchName}}', bet.matchName),
          });

          cantBePlayed += 1;
        }

        if (ticketType === 2) {
          bet.ticketBetBank = item.banker ? 1 : 0;
        }

        ticket.bets.push(bet);
      });

      if (cantBePlayed === 0) {
        GravityGateway.sendMessage('Tickets.Pay', {
          ticket,
          ticketFormatted: ticket,
          validateTicketPayinLimit: false,
          validateTicket: false,
        });
      }
    },
    clearBetslip() {
      this.$store.dispatch('clearBetslip');
    },
    changeType(tab) {
      if (parseInt(this.activeTab.id, 10) !== parseInt(tab.id, 10)) {
        this.$store.dispatch('changeTicketType', parseInt(tab.id, 10));
      }
    },
    toggleBanker(key) {
      this.$store.dispatch('toggleBanker', key);
    },
    goToEventView({ matchId }) {
      if (!matchId.toUpperCase().startsWith('O')) {
        this.$router.push({
          name: 'EventView',
          params: {
            id: matchId,
          },
        });
        this.$store.dispatch('toggleBetslip');
      }
    },
    changeStake(stake) {
      this.$store.dispatch('updateStake', stake);
    },
    getTypeName(key) {
      return this.$store.getters.getTranslation(`ticket.${key}`);
    },
    getTranslation(key) {
      return this.$store.getters.getTranslation(key);
    },
    enterKey(key) {
      const stake = this.currentStakeModalValue;

      if (key === 'OK') {
        if (stake !== '' && stake !== 0 && parseFloat(stake) !== 0) {
          this.changeStake(parseFloat(stake));
        }
        this.currentStakeModalValue = '';
        return;
      }

      if (stake.length >= 13 && ['C', 'DEL'].indexOf(key) === -1) {
        return;
      }
      if (key === '.' && ((stake.indexOf('.') !== -1) || stake.length === 0 || (stake.length - 1) >= 13)) {
        return;
      }

      if (key === 'C') {
        this.currentStakeModalValue = this.currentStakeModalValue.slice(0, -1);
        return;
      }

      if (key === 'DEL') {
        this.currentStakeModalValue = '';
        return;
      }

      if ((stake.indexOf('.') !== -1) && stake[stake.length - 3] === '.') {
        return;
      }
      this.currentStakeModalValue += key;
    },
  },
};
</script>

<style lang="scss">
@import '../../../scss/default/modules/betslip';
</style>
